import axios from 'axios';

// Constants
import { CAT42_AUTH } from 'app/constants/LocalStorageKeysConstants';

export function getAuthToken() {
  const auth = JSON.parse(localStorage.getItem(CAT42_AUTH));
  return auth?.accessToken;
}

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use(
  (config) => {
    const token = getAuthToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

api.interceptors.response.use(
  (config) => config,
  (error) => {
    if (
      error.response.status === 401 &&
      window.location.pathname !== '/login'
    ) {
      localStorage.removeItem(CAT42_AUTH);
      window.location.reload();
    }

    return Promise.reject(error);
  },
);

export default api;
